import React, { useEffect } from "react"
import { useState } from "react"
import Header from "../../components/navigation/Header"
import Footer from "../../components/navigation/Footer"
import GetCSFR from "../../hooks/userAuthentication/GetCSFR"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRightLong, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"
import CoachPreview from "../../components/general/club-preview/CoachPreview"
import axios from "axios"
import AddCoach from "../../components/general/club-preview/AddCoach"
import RemoveCoach from "../../components/general/club-preview/RemoveCoach"

interface Summary {
    bookings: number;
    revenue: number;
    newClients: number;
    conversions: number;
    clubName: string;
}

interface CoachProfile {
    id: string;
    fullname: string;
    specialization: string;
    location: string;
    rating: number;
}

export default function ClubDashboard(){
    const csrfToken = GetCSFR({ name: "csrftoken" })
    const [summary, setSummary] = useState<Summary>({bookings: 0, revenue: 0, newClients: 0, conversions: 0, clubName: 'Club'})
    const [coaches, setCoaches] = useState<CoachProfile[]>()
    const [openAddCoachModal, setOpenAddCoachModal] = useState<boolean>(false)
    const [openRemoveCoachModal, setOpenRemoveCoachModal] = useState<boolean>(false)

    useEffect(()=>{
        document.title = 'SkillJa - Club Dashboard'

        axios.get(`${process.env.REACT_APP_SKILLJA_URL}/auth/club/get_club_coaches/`, { 
            headers: {
                'X-CSRFToken': csrfToken,
                'Content-Type': 'application/json'
            }, 
            withCredentials: true
            }) 
            .then(res => {
                if(res.status===200){
                    setCoaches(res.data.coaches)
                } 
            })
            .catch(error => {console.error(error)})

        axios.get(`${process.env.REACT_APP_SKILLJA_URL}/auth/club/get_club_summary/`, { 
            headers: {
                'X-CSRFToken': csrfToken,
                'Content-Type': 'application/json'
            },
            withCredentials: true
            }) 
            .then(res => {
                if(res.status===200){
                    setSummary(res.data.summary)
                } 
            })
            .catch(error => {console.error(error)})
    },[])


    return (
        <div className="flex flex-col">
            <Header useCase="protected" />
            <section className="flex justify-center items-start flex-wrap mt-8 mb-16 lg:mb-32">
                <h1 className="font-semibold text-xl lg:text-3xl text-center w-full mx-auto mb-10">{summary.clubName} Dashboard</h1>
                <section className="border border-main-grey-100 rounded-xl bg-white w-full max-w-xl h-[32rem] font-kulim py-4 px-8 lg:mr-8">
                    <div className="flex mb-8 ">
                        <h2 className="font-semibold text-xl mr-auto my-auto">
                            Coach List
                        </h2>
                        {/* <div className="flex border border-main-grey-100 rounded-3xl py-1.5 px-5 w-40 lg:w-56">
                            <FontAwesomeIcon icon={faMagnifyingGlass} className="mr-auto my-auto text-main-grey-200" />
                            <input type="text" className="ml-3 my-auto w-40 focus:outline-none" />
                        </div> */}
                    </div>
                    <div className="flex flex-col h-96 overflow-scroll">
                        {coaches ?
                            coaches?.map((coach, index)=> {
                                return (
                                    <CoachPreview key={index} id={coach.id} fullname={coach.fullname} specialization={coach.specialization} location={coach.location} rating={coach.rating} />
                                )
                            })
                        :
                            <p className="text-center mx-auto mt-10">No coaches belong to this club</p>
                        } 
                    </div>
                </section>
                <section className="flex flex-col justify-center items-center font-kulim w-full max-w-lg">
                    <div className="border border-main-grey-100 rounded-xl bg-white w-full pt-4 pb-6 px-8 mb-8">
                        <h2 className="font-semibold text-xl mr-auto mb-4">
                            Monthly Summary
                        </h2>
                        <div className="flex flex-wrap">
                            <div className="flex flex-col justify-center items-center border border-main-grey-100 rounded-bl-xl rounded-tl-lg py-2 px-4">
                                <p className="mx-auto text-center mb-3">
                                    Bookings
                                </p>
                                <p className="mx-auto text-center text-sm">
                                    {summary.bookings}
                                </p>
                            </div>
                            <div className="flex flex-col justify-center items-center border border-main-grey-100 py-2 px-4">
                                <p className="mx-auto text-center mb-3">
                                    Revenue
                                </p>
                                <p className="mx-auto text-center text-sm">
                                    ${summary.revenue}
                                </p>
                            </div>
                            <div className="flex flex-col justify-center items-center border border-main-grey-100 py-2 px-4">
                                <p className="mx-auto text-center mb-3">
                                    New Clients
                                </p>
                                <p className="mx-auto text-center text-sm">
                                    {summary.newClients}
                                </p>
                            </div>
                            <div className="flex flex-col justify-center items-center border border-main-grey-100 rounded-br-xl rounded-tr-lg  py-2 px-4">
                                <p className="mx-auto text-center mb-3">
                                    Conversions
                                </p>
                                <p className="mx-auto text-center text-sm">
                                    {summary.conversions}%
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="border border-main-grey-100 rounded-xl bg-white w-full py-4 px-8 mb-8">
                        <div className="flex">
                            <h2 className="font-semibold text-xl mr-auto mb-4">
                                Financial Report
                            </h2>
                            <FontAwesomeIcon icon={faArrowRightLong} className="text-xl ml-auto cursor-pointer hover:text-main-green-500"/>
                        </div>
                        <div className="flex flex-col ">
                            <Link to={'./financial-report?date=yesterday'} className="underline text-sm cursor-pointer w-fit mb-2.5 hover:text-main-green-500">
                                Yesterday
                            </Link>
                            <Link to={'./financial-report?date=lastsevendays'} className="underline text-sm cursor-pointer w-fit mb-2.5 hover:text-main-green-500">
                                Last 7 Days
                            </Link>
                            <Link to={'./financial-report?date=currentmonth'} className="underline text-sm cursor-pointer w-fit mb-2 hover:text-main-green-500">
                                Current Month
                            </Link>
                        </div>
                    </div>
                    <div className="border border-main-grey-100 rounded-xl bg-white w-full pt-4 pb-6 px-8">
                        <h2 className="font-semibold text-xl mr-auto mb-4">
                            Quick Actions
                        </h2>
                        <div className="flex flex-wrap">
                            <button className="form-btn py-2 px-4 text-sm mr-3" onClick={()=>setOpenAddCoachModal(true)}>
                                Add Coach
                            </button>
                            <button className="form-btn py-2 px-4 text-sm" onClick={()=>setOpenRemoveCoachModal(true)}>
                                Remove Coach
                            </button>
                        </div>
                    </div>
                </section>
            </section>
            {openAddCoachModal && <AddCoach displayForm={setOpenAddCoachModal}/> }
            {openRemoveCoachModal && <RemoveCoach displayForm={setOpenRemoveCoachModal} coachList={coaches}/> }
            <Footer />
        </div>
    )
}